<template>
    <CheckoutSubMaterial></CheckoutSubMaterial>
</template>

<script>
import { defineAsyncComponent } from "vue";

const AuthLayout = defineAsyncComponent(() =>
    import("../../../Layouts/AuthLayout.vue")
);
const CheckoutSubMaterial = defineAsyncComponent(() =>
    import(
        "../../../components/ProjectManagement/HelpPage/EngineeringWorkbench/CheckoutSubMaterial.vue"
    )
);

export default {
    name: "Project_HelpCheckoutSubMaterial", //The name you are in should not equal the name of the component you are importing.
    components: { CheckoutSubMaterial, AuthLayout },
};
</script>
